import {
  Integration,
  IntegrationType,
  IntegrationVendor,
} from 'studio5/pages/integrations/integrations.types';
import {
  INTEGRATIONS,
  IntegrationId,
} from 'studio5/pages/integrations/metadata';

export const isIntegrationId = (key: string): key is IntegrationId => {
  return key in INTEGRATIONS;
};

export const isAppcuesIntegration = (integration: Integration) => {
  return integration.integrationType === IntegrationType.APPCUES_JS_SDK;
};

export const isPrismaticIntegration = (integration: Integration) => {
  return integration.integrationVendor === IntegrationVendor.PRISMATIC;
};

export const isDocumentationIntegration = (integration: Integration) => {
  return integration.integrationType === IntegrationType.DOCUMENTATION_ONLY;
};
